/**
 * Civil Nexus - Native IndexedDB Engine (Version 4)
 * شامل مایگریشن زنجیره‌ای و نرمال‌سازی درجا (In-Place Record Normalization)
 */

const DB_NAME = 'CivilNexus_EngineDB';
const DB_VERSION = 4;

export const openDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      const oldVersion = event.oldVersion;
      const tx = event.target.transaction;

      console.log(`[DB Migration] Chained migration executing: v${oldVersion} -> v${DB_VERSION}`);

      // گام ۱: زیرساخت اولیه مخازن پروژه‌ها و رکوردها
      if (oldVersion < 1) {
        if (!db.objectStoreNames.contains('projects')) {
          db.createObjectStore('projects', { keyPath: 'id' });
        }
        if (!db.objectStoreNames.contains('records')) {
          const recordStore = db.createObjectStore('records', { keyPath: 'id' });
          recordStore.createIndex('projectId', 'projectId', { unique: false });
          recordStore.createIndex('type', 'type', { unique: false });
          recordStore.createIndex('timestamp', 'timestamp', { unique: false });
        }
      }

      // گام ۲: مخزن فایل‌های باینری و تنظیمات محلی
      if (oldVersion < 2) {
        if (!db.objectStoreNames.contains('files')) {
          const fileStore = db.createObjectStore('files', { keyPath: 'id' });
          fileStore.createIndex('projectId', 'projectId', { unique: false });
          fileStore.createIndex('recordId', 'recordId', { unique: false });
          fileStore.createIndex('type', 'type', { unique: false });
        }
        if (!db.objectStoreNames.contains('settings')) {
          db.createObjectStore('settings', { keyPath: 'key' });
        }
      }

      // گام ۳: استور لاگ‌های ممیزی
      if (oldVersion < 3) {
        if (!db.objectStoreNames.contains('audit_logs')) {
          const auditStore = db.createObjectStore('audit_logs', { keyPath: 'id' });
          auditStore.createIndex('projectId', 'projectId', { unique: false });
          auditStore.createIndex('timestamp', 'timestamp', { unique: false });
          auditStore.createIndex('action', 'action', { unique: false });
        }
      }

      // گام ۴: ایجاد ایندکس‌های CDE و نرمال‌سازی رکوردهای قدیمی با Cursor
      if (oldVersion < 4) {
        const recordStore = tx.objectStore('records');

        if (!recordStore.indexNames.contains('rootId')) {
          recordStore.createIndex('rootId', 'rootId', { unique: false });
        }
        if (!recordStore.indexNames.contains('status')) {
          recordStore.createIndex('status', 'status', { unique: false });
        }

        // نرمال‌سازی درون‌جا برای اسناد فاقد شماره ویرایش
        const cursorReq = recordStore.openCursor();
        cursorReq.onsuccess = (e) => {
          const cursor = e.target.result;
          if (cursor) {
            const r = cursor.value;
            let modified = false;

            if (!r.rootId) {
              r.rootId = r.id;
              modified = true;
            }
            if (r.revision === undefined) {
              r.revision = 1;
              modified = true;
            }
            if (!r.status) {
              r.status = 'active';
              modified = true;
            }
            if (r.previousRevisionId === undefined) {
              r.previousRevisionId = null;
              modified = true;
            }

            if (modified) {
              cursor.update(r);
            }
            cursor.continue();
          }
        };
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = (e) => reject('IndexedDB open error: ' + e.target.error);
  });
};

export const promisifyRequest = (request) => {
  return new Promise((resolve, reject) => {
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
};

// بازگردانی تابع کمکی تراکنش‌ها برای مخازن پروژه و فایل
export const executeTx = async (storeNames, mode, callback) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeNames, mode);
    let result;
    tx.oncomplete = () => resolve(result);
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
    try {
      result = callback(tx);
    } catch (err) {
      reject(err);
    }
  });
};
